'use strict'

/**
 * Project easy title 24
 * Created by hielo on 2018-11-08
 */

import loginButton from './login-button.vue'
import adminButton from './admin-button.vue'
import creditCard from './credit-card.vue'
import invoiceDetail from './invoice-detail.vue'
import contactsBlock from './contacts.vue'
import projectReportPopup from './project-report-popup.vue'
import orderDetailPopup from './order-detail-popup.vue'
import helpButton from 'Common/components/help-button.vue'

// Dialogs
import infoDialog from './dialogs/info.vue'

function components (Vue, options) {
	// Other components
	Vue.component('login-button', loginButton)
	Vue.component('admin-button', adminButton)
	Vue.component('credit-card', creditCard)
	Vue.component('invoice-detail', invoiceDetail)
	Vue.component('contacts-block', contactsBlock)
	Vue.component('project-report-popup', projectReportPopup)
	Vue.component('order-detail-popup', orderDetailPopup)
	Vue.component('help-button', helpButton)

	// Dialogs
	Vue.component('info-dialog', infoDialog)
}

export default components



// WEBPACK FOOTER //
// ./src/common/components/index.js